import { OnBoardingCheckboxProps } from '@/types/props/components/onboarding';
import { Checkbox, Field, Label } from '@headlessui/react';
import clsx from 'clsx';
import { IoIosCheckmark } from 'react-icons/io';

export default function SpiritoryCheckbox({
  label,
  checked,
  onChange,
  size,
  weight,
  color,
  squared,
  checkboxColor,
  checkIcon,
  position = 'center',
  ...props
}: OnBoardingCheckboxProps) {
  return (
    <Field
      className={clsx('tw-flex tw-gap-2', {
        ['tw-items-center']: position === 'center',
        ['tw-items-start']: position === 'top',
        ['tw-items-end']: position === 'bottom',
      })}
    >
      <Checkbox
        {...props}
        checked={checked}
        onChange={onChange}
        className={clsx(
          `
            tw-relative tw-flex tw-items-center tw-justify-center
            tw-bg-white tw-border tw-border-solid
            tw-transition-all
            data-[checked]:tw-border-main
            focus:outline-none focus:ring-2 focus:ring-main focus:ring-offset-2
            tw-w-5 tw-h-5 max-nine:tw-w-4 max-nine:tw-h-4
            tw-shrink-0
            `,
          {
            ['tw-rounded-md']: Boolean(squared) === true,
            ['tw-rounded-full']: Boolean(squared) === false,
            ['tw-border-main']: checkboxColor === 'main',
            ['tw-border-gray-300']: checkboxColor === 'gray',
          }
        )}
        aria-checked={checked}
      >
        <div
          className={clsx(
            'tw-absolute tw-transition-opacity tw-duration-200 tw-left-2/4 tw-top-2/4 tw-transform tw--translate-x-2/4 tw--translate-y-2/4 tw-flex tw-items-center tw-justify-center',
            checked ? 'tw-opacity-100' : 'tw-opacity-0',
            checkIcon ? 'tw-w-5 tw-h-5' : 'tw-w-3 tw-h-3 tw-bg-main',
            Boolean(squared) ? 'tw-rounded-sm' : 'tw-rounded-full'
          )}
        >
          {checkIcon && (
            <IoIosCheckmark className="tw-text-main tw-text-base" />
          )}
        </div>
      </Checkbox>
      <Label
        className={clsx(
          'tw-font-plusJakartaSans tw-leading-[22.68px] max-nine:!tw-text-base',
          {
            ['tw-text-textBlack']: color === 'black',
            ['tw-text-gray-900']: color === 'gray',
            ['tw-font-medium']: weight === 'medium',
            ['tw-font-bold']: weight === 'bold',
            ['tw-text-lg']: size === 'big',
            ['tw-text-base']: size === 'medium',
            ['tw-text-sm']: size === 'small',
          }
        )}
      >
        {label}
      </Label>
    </Field>
  );
}
